/* eslint-disable @typescript-eslint/no-shadow */
import React, {
  Suspense, useEffect, useMemo, useState,
} from 'react';
import BackIcon from 'Components/common/assets/svgIcons/BackIcon';
import NavBarPrimary, { chatActions, chatStates } from 'Components/layout/headers/NavBarPrimary';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import {
  selectedTeamSRI,

  selectOverviewFilter, selectSRICardData, selectSRICardLoading,
  selectSRISelectedUser, selectSRISelectedUserId,
  selectSRITabs, selectTeamReadinessFiltersLoading,
  selectTeamReadinessRegions, selectTeamReadinessSelectedRegion, selectTeamReadinessTeams,
} from 'Selector/SRISelector';
import FeedStyle from 'Style/FeedStyle';
import PersonStyle from 'Style/PersonStyle';
import styled from 'styled-components';
import { actions as SRIActions } from 'Slice/SRISlice';
import DrawerAlerts from 'Components/alerts/components/DrawerAlerts';
import AccountPopOver from 'Components/common/components/AccountPopOver';
import GlobalSearch from 'Components/globalSearch/components/GlobalSearch';
import Tabs from 'Components/common/tabs/Tabs';

import OverViewTab from 'Components/sri/OverViewTab';
import EngagementTab from 'Components/sri/EngagementTab';
import TeamReadinessTab from 'Components/sri/TeamReadinessTab';
import LeaderBoardTab from 'Components/sri/LeaderBoardTab';
import { maxWidth, primaryColor, retina } from 'Utils/utilsStyle';
import SRIDropdownFilter from 'Components/sri/SRIDropdownFilter';
import { FiltersTypeObject, SRIFilters, SRITeamReadinessTeam } from 'Types/SRITypes';
import { SRI } from 'Utils/SRIConstants';
import { getQueryUserId } from 'Utils/UtilityFunctions';
import SRISvg from 'Components/layout/assets/SRISvg';
import DropdownFilter from 'Components/sri/DropdownFilter';
import { Menu } from 'antd';
import SriProfileSkeleton from 'Components/sri/FullComponentSkeletons/SriProfileSkeleton';
import OverViewTabSkeleton from 'Components/sri/FullComponentSkeletons/OverViewTabSkeleton';
import SubNavBarPrimary from 'Components/layout/headers/SubNavBarPrimary';
import classNames from 'classnames';
import { selectShowGlobalGilroy, selectUserCreationDate, selectWbUsagePermission } from 'Selector/GlobalSearchContentSelector';
import { actions as UiAction } from 'Slice/UISlice';
import DrawerPeopleGroup from 'Components/people/components/DrawerPeopleGroup';
import { actions as groupActions } from 'Slice/GroupsSlice';
import { Gilroy } from 'gilroy-global';
import { useGilroy } from 'Utils/hooks/useGilroy';
import { APP_USAGE } from 'Utils/Constants';
import SriProfile from 'Components/sri/SriProfile';

const Wrapper = styled.div`
  .active-c {
    color: ${primaryColor} !important;
  }
  .tabsNav {
    margin-top: 25px;
    display: flex;
    align-content: center;
    justify-content: center;
    align-items: center;
  }
  .tabSection {
    padding-top: 25px;
  }
  .filterIconMode {
    margin-left: 10px;
  }
  .filter-span {
    display: inline-flex;
  }
  .sub-header-wrapper {
    .tabs-wrapper {
      a {
        white-space: pre;
      }
    }
    .DateRangePiker {
      span {
        white-space: pre;
      }
    }
  }
  .progress-social {
    display: none !important;
  }
  .heading-inner-page {
    .tips-placeholder {
      .tabs-item {
        .open-in-new-tab {
          @media all and (max-width: ${maxWidth}), ${retina} {
            margin-left: 4px;
            width: 10px;
            height: 10px;
          }
        }
      }
    }
  }
`;

const Header = styled.div`
  display: flex;
  justify-content: center;
`;

type TabsInterface = {
  [key: string]: JSX.Element
};

type Params = {
  section: string
};

const SalesIndex = function SalesIndex() {
  const { gilroyStates, gilroyActions } = useGilroy();
  const { section } = useParams<Params>();
  const { saveUrl: savedUrlV2 } = chatStates;
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [isRegionFilterActive, setIsRegionFilterActive] = useState(false);
  const [isTeamFilterActive, setIsTeamFilterActive] = useState(false);

  const wbUsagePermission = useSelector(selectWbUsagePermission);
  const navArray: string[] = useSelector(selectSRITabs);
  const SRIfilters: SRIFilters = useSelector(selectOverviewFilter);
  // const [currFilter, setCurrFilter] = useState({ start_date: '', end_date: '' });

  const sriCardLoading = useSelector(selectSRICardLoading);
  const sriCardDetails = useSelector(selectSRICardData);
  const sriSelectedUserId = useSelector(selectSRISelectedUserId);
  const sriSelectedUser = useSelector(selectSRISelectedUser);
  const showGlobalGilroy = useSelector(selectShowGlobalGilroy);
  const userCreationDate = useSelector(selectUserCreationDate);
  const [dragging, setDragging] = useState(false);
  const filtersLoading = useSelector(selectTeamReadinessFiltersLoading);
  const filterRegions = useSelector(selectTeamReadinessRegions);
  const filterTeams = useSelector(selectTeamReadinessTeams);
  const selectedTeam: SRITeamReadinessTeam = useSelector(selectedTeamSRI);
  const selectedRegion = useSelector(selectTeamReadinessSelectedRegion);
  const currentUrl = window.location.href;
  const regionTeams = filterTeams[selectedRegion];
  const [openCreateModal, setOpenCreateModal] = useState(false);
  const [showNew, setShowNew] = useState(false);

  const queryUserId = getQueryUserId();

  const toggle = (flag: boolean) => {
    setOpenCreateModal(flag);
  };

  const tabs: TabsInterface = {
    overview: (
      <Suspense
        fallback={
          <OverViewTabSkeleton />
        }
      >
        <OverViewTab />
      </Suspense>
    ),
    myengagement: <EngagementTab />,
    teamreadiness: sriSelectedUserId ? <OverViewTab /> : <TeamReadinessTab />,
    leaderboard: <LeaderBoardTab />,
  };

  const getFormObject = ({ type, sections }: FiltersTypeObject) => ({
    __TYPE__: type,
    sections,
    filters: [{ type, ...SRIfilters }],
    ...(sriSelectedUserId ? { user_id: sriSelectedUserId } : {}),
  });

  useEffect(() => {
    if (wbUsagePermission) {
      dispatch(SRIActions.addSriTab(APP_USAGE));
    }
  }, [wbUsagePermission]);

  useEffect(() => {
    window.scroll(0, 0);
    dispatch(SRIActions.getTeamReadinessFiltersDetails({}));
    if (queryUserId && sriSelectedUserId !== queryUserId) {
      dispatch(SRIActions.setSelectedUserId(queryUserId));
    } else {
      dispatch(SRIActions.setSelectedUserId(null));
    }
    if (savedUrlV2 !== currentUrl) {
      dispatch(UiAction.isShowGilroyGlobalToggle(false));
      chatActions.setShowLibrary(true);
      chatActions.setShowExamplePrompts(false);
      chatActions.resetChatHistory();
      chatActions.setSelectedConversationId(-1);
      chatActions.setHistoryPanelOpened(false);
    } else {
      chatActions.setSaveUrl('');
      chatActions.setSaveProfileName('');
    }
  }, []);

  useEffect(() => {
    if (SRIfilters.start_date !== ''
      && SRIfilters.end_date !== '') {
      dispatch(SRIActions.getSRICardDetails(getFormObject(SRI.USER_SCORE)));
    }
  }, [SRIfilters, sriSelectedUserId, userCreationDate]);

  useEffect(() => {
    if (queryUserId === 0 && sriSelectedUserId) {
      dispatch(SRIActions.setSelectedUserId(null));
    }
  }, [queryUserId]);

  const setRegion = ({ key }: { key: string }) => {
    if (section === 'teamreadiness') {
      dispatch(SRIActions.setTeamReadinessFilterRegion(key));
    }
    dispatch(SRIActions.setLeaderBoardFilterRegion(key));
  };

  const setTeam = ({ key }: { key: string }) => {
    const teamData = regionTeams.find((team) => team.team_id.toString() === key);

    if (teamData) {
      if (section === 'teamreadiness') {
        dispatch(SRIActions.setTeamReadinessFilterTeam(teamData));
      } else { dispatch(SRIActions.setLeaderBoardFilterTeam(teamData)); }
    }
  };

  useEffect(() => {
    setShowNew(false);
    setOpenCreateModal(dragging);
  }, [dragging]);

  const isDrag = (a: boolean) => {
    if (a) dispatch(groupActions.setDropComplete(false));
    setDragging(a);
  };

  const regionMenu = (
    <Menu onClick={setRegion}>
      {filterRegions?.map((region) => (
        <Menu.Item key={region} className={region === selectedRegion ? 'active-c' : ''}>
          {region}
        </Menu.Item>
      ))}
    </Menu>
  );

  const teamMenu = (
    <Menu onClick={setTeam} className="menu-styles">
      {regionTeams?.map((team) => (
        <Menu.Item key={team?.team_id} className={team?.team_id === selectedTeam?.team_id ? 'active-c' : ''}>
          {team?.team_name}
        </Menu.Item>
      ))}
    </Menu>
  );

  useEffect(() => {
    if (selectedRegion !== 'All Regions') {
      setIsRegionFilterActive(true);
    } else {
      setIsRegionFilterActive(false);
    }
  }, [selectedRegion]);

  useEffect(() => {
    if (selectedTeam?.team_name !== 'All Teams') {
      setIsTeamFilterActive(true);
    } else {
      setIsTeamFilterActive(false);
    }
  }, [selectedTeam]);

  return (
    <Wrapper>
      <PersonStyle />
      <FeedStyle />
      <NavBarPrimary headerClassName="no-overflow-on-header">
        <div className="left-side-wrap">
          {sriSelectedUserId ? <BackIcon onClick={() => navigate(-1)} /> : <SRISvg />}
          <h1 className={`heading ${sriSelectedUserId ? '' : 'hide-border-left'}`}>
            Sales Sigma
          </h1>
        </div>
        <div className="right-side-wrap">
          <GlobalSearch />
          <DrawerAlerts />
          <AccountPopOver />
        </div>
      </NavBarPrimary>
      <SubNavBarPrimary>
        <div className="heading-inner-page tabs-placeholder sri-page-nav wrap-slider hidden-scroll">
          <div className="head-wrap" />
          <div className="tips-placeholder">
            <Tabs
              baseComponentPath="sri"
              tabsName={navArray}
              loading={sriCardLoading}
              removeSearch={!!sriSelectedUserId}
              elementTarget="tabs-details"
              headerAppendTab
            />
          </div>
          <div className={classNames('filter-placeholder filter-span', { notDisabledFilter: section === 'teamreadiness' && queryUserId < 1 })}>
            {section === 'teamreadiness' ? (
              <div className="filters">
                {filtersLoading ? null
                  : (
                    <Header className="filter-sri-wrapper">
                      <div className="mr-1 ml-1">
                        <DropdownFilter
                          menu={regionMenu}
                          filterTitle={selectedRegion}
                          isActive={isRegionFilterActive}
                        />
                      </div>
                      <DropdownFilter
                        menu={teamMenu}
                        filterTitle={selectedTeam?.team_name}
                        isActive={isTeamFilterActive}
                      />
                    </Header>
                  )}
              </div>
            ) : null}
            <SRIDropdownFilter />
          </div>

        </div>
      </SubNavBarPrimary>
      <div className="container">
        {/* SRI Overview Card here */}
        <div className="p-relative">
          <Suspense
            fallback={
              <SriProfileSkeleton />
            }
          >
            <SriProfile
              sriCardLoading={sriCardLoading}
              sriCardDetails={sriSelectedUserId
                ? sriSelectedUser.cardDetails : sriCardDetails}
              isDrag={isDrag}
            />
          </Suspense>
        </div>
        {useMemo(
          () => (
            <div id="tabs-details" className="tabSection">
              {tabs[section || 'overview']}
            </div>
          ),
          [section, sriSelectedUserId],
        )}
      </div>
      {showGlobalGilroy
        ? (
          <Gilroy gilroyStates={gilroyStates} gilroyActions={gilroyActions} />
        ) : null}
      <DrawerPeopleGroup
        openNewCreate={openCreateModal}
        setOpenNew={toggle}
        showNew={showNew}
        toggleShowNew={(bool: boolean) => setShowNew(bool)}
        noButton
        drag={dragging}
      />
    </Wrapper>
  );
};

export default SalesIndex;
